import { colors } from './designTokens';

/** Premium type scale — display for heroes, sans for UI via <Text variant="..." /> */
export const text = {
  eyebrow: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '0.7rem', sm: '0.75rem' },
    fontWeight: 600,
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    lineHeight: 1.4,
  },
  hero: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: { xs: '3rem', sm: '4rem', md: '5.5rem', lg: '6.5rem' },
    fontWeight: 500,
    lineHeight: 1.02,
    letterSpacing: '-0.02em',
  },
  h1: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: { xs: '2.5rem', sm: '3.25rem', md: '4rem' },
    fontWeight: 500,
    lineHeight: 1.08,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: { xs: '2rem', sm: '2.5rem', md: '3.25rem' },
    fontWeight: 500,
    lineHeight: 1.12,
    letterSpacing: '-0.02em',
  },
  h3: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.45rem' },
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '1.05rem', md: '1.1rem' },
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
  },
  subtitle: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '1.05rem', md: '1.2rem' },
    lineHeight: 1.7,
    fontWeight: 400,
  },
  body: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '0.95rem', md: '1rem' },
    lineHeight: 1.75,
  },
  bodySm: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '0.875rem', md: '0.9rem' },
    lineHeight: 1.7,
  },
  caption: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '0.8rem', md: '0.85rem' },
    lineHeight: 1.6,
  },
  label: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: '0.8rem',
    fontWeight: 600,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    lineHeight: 1.4,
  },
  stat: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: { xs: '2rem', md: '2.75rem' },
    fontWeight: 500,
    letterSpacing: '-0.02em',
    lineHeight: 1,
  },
  step: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: '2rem',
    fontWeight: 500,
    lineHeight: 1,
  },
  ctaTitle: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: { xs: '2rem', md: '3rem' },
    fontWeight: 500,
    letterSpacing: '-0.02em',
    lineHeight: 1.15,
  },
  ctaBody: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '1rem', md: '1.1rem' },
    lineHeight: 1.75,
  },
  list: {
    fontFamily: '"DM Sans", "Inter", sans-serif',
    fontSize: { xs: '0.95rem', md: '1rem' },
    lineHeight: 1.7,
    fontWeight: 500,
  },
  quote: {
    fontFamily: '"Cormorant Garamond", "Georgia", serif',
    fontSize: { xs: '1.15rem', md: '1.4rem' },
    lineHeight: 1.6,
    fontStyle: 'italic',
    fontWeight: 400,
  },
};

export const textColors = {
  primary: colors.navy,
  secondary: colors.slate,
  muted: colors.textMuted,
  white: colors.white,
  gold: colors.gold,
  goldDark: colors.goldDark,
  ochre: colors.ochre,
  ochreLight: colors.ochreLight,
  ochreMuted: colors.ochreMuted,
  silver: colors.silver,
  blue: colors.blue,
  error: '#d32f2f',
};
